var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-root",style:({
    height: _vm.height + 'px',
    'max-height': _vm.height + 'px',
  })},[_c('div',{staticClass:"menu-header"},[_vm._v(" "+_vm._s(_vm.objectType)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }